export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_15.73a9c0c8.jpg";